export const getDisplayNameLocaleKey = (displayNameKey: string) =>
  `common:default_role_names.${displayNameKey}`;
